@import "../../global/temporary-mercury-overrides/_button.scss";

:host {
  display: grid;
  grid-template-rows: max-content 1fr max-content;
  block-size: 100%;
  overflow: auto;
}

.section {
  // just for semantics (allows header and footer element)
  display: contents;
}

.header {
}

.main {
  display: grid;
  grid-template-rows: 1fr max-content;
  overflow: auto;
}
.field-group-name-description-module {
  grid-template-areas:
    "name-label name-input"
    "description-label description-input"
    "module-label module-entity-selector";
  grid-template-columns: max-content 1fr;
}

.name-label {
  grid-area: name-label;
}
.name-input {
  grid-area: name-input;
}
.description-label {
  grid-area: description-label;
}
.description-input {
  grid-area: description-input;
}
.module-label {
  grid-area: module-label;
}
.module-entity-selector {
  grid-area: module-entity-selector;
}
.radio-file-input-wrapper {
  grid-template-columns: max-content 1fr;
}
div.field-file-input {
  grid-template-columns: 1fr max-content;
}

.json-area {
  display: grid;
  grid-template-rows: 1fr max-content;
  overflow: auto;
}
.slotted-container {
  overflow: auto;
  block-size: 100%;
}

.assume-varchar-checkbox {
  margin-inline-start: 16px;
  margin-block-end: 16px;
  inline-size: max-content;
}

.input-file {
  display: grid;
  grid-template-columns: 1fr max-content;
}

.radio-group {
  gap: 30px !important;
}
.tooltip {
  height: 0px;
}
